import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';
import { getQuery } from '@/helpers/utils';

export const cashService = {
  balance: () => axios.get(Pathes.Dashboard.balance),
  paymentMethods: () => axios.get(Pathes.LHV.methods),
  calculateTotalAmount: params =>
    axios.get(Pathes.Funds.calculate + getQuery(params)),
  paymentResult: params =>
    axios.get(Pathes.LHV.paymentSession + getQuery(params)),
  withdrawInfo: () => axios.get(Pathes.Funds.withdrawInfo),
  cancelWithdrawRequest: reqId =>
    axios.delete(Pathes.Funds.withdrawRequest(reqId)),
  createWithdrawRequest: payload =>
    axios.post(Pathes.Funds.withdrawReq, payload),
  withdrawHistory: params =>
    axios.get(Pathes.Funds.withdrawHistory + getQuery(params)),
  bankAccounts: () => axios.get(Pathes.Funds.bankDetails),
  deleteBankAccount: id => axios.delete(Pathes.Funds.bankDetailByID(id)),
  bankAccountDetail: id => axios.get(Pathes.Funds.bankDetailByID(id)),
  checkIbanNumber: payload => axios.post(Pathes.Funds.ibanCheck, payload),
  createBankAccount: payload => axios.post(Pathes.Funds.bankDetails, payload),
  updateBankAccount: (id, payload) =>
    axios.put(Pathes.Funds.bankDetailByID(id), payload),
  checkCountrySepa: countryCode =>
    axios.get(Pathes.Funds.countryInSepa(countryCode)),
};
